import { Spin } from 'antd';
import { reactions } from '../Reactions/reactions';
import Styles from './styles';
import { LoadingOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

const { Container, ReactionsContainer, Reaction } = Styles;

type Props = {
  onReact: (reaction: string) => void;
  isReacting: boolean;
};

export const ReactionsController: React.FC<Props> = ({ onReact, isReacting }) => {
  const [loadingReaction, setLoadingReaction] = useState<string>('');

  useEffect(() => {
    if (!isReacting) {
      setLoadingReaction('');
    }
  }, [isReacting]);

  const reactionsMap = Object.entries(reactions).map(([key, value]) => ({
    emoji: value,
    value: key,
  }));

  return (
    <Container>
      <ReactionsContainer>
        {reactionsMap.map(reaction => (
          <Reaction
            key={reaction.value}
            onClick={() => {
              setLoadingReaction(reaction.value);
              onReact(reaction.value);
            }}
          >
            <Spin
              indicator={<LoadingOutlined spin />}
              size="small"
              spinning={loadingReaction === reaction.value}
            >
              {reaction.emoji}
            </Spin>
          </Reaction>
        ))}
      </ReactionsContainer>
    </Container>
  );
};
